export type PagingParams = {
  pageIndex: number;
  pageSize: number;
  sortCol: string;
  sortDir: string;
};

export function setPagingParams({ pageIndex, pageSize, sortCol, sortDir }: PagingParams) {
  let result = `pageIndex=${pageIndex}`;
  result += pageSize && `&pageSize=${pageSize}`;
  result += sortCol && `&sortCol=${sortCol}`;
  result += sortDir && `&sortDir=${sortDir}`;
  return result;
}
